var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3397 17.4C19.3397 17.7314 19.0711 18 18.7397 18H10.9397C10.6084 18 10.3397 17.7314 10.3397 17.4C10.3397 17.0686 10.6084 16.8 10.9397 16.8H18.1397V7.2H10.9397C10.6084 7.2 10.3397 6.93137 10.3397 6.6C10.3397 6.26863 10.6084 6 10.9397 6H18.7397C19.0711 6 19.3397 6.26863 19.3397 6.6V17.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39598 12.396C5.20159 12.2016 5.17999 11.8999 5.33118 11.6816L5.39598 11.6041L7.77186 9.22817C7.99055 9.00948 8.34513 9.00948 8.56382 9.22817C8.75821 9.42257 8.77981 9.72432 8.62862 9.94257L8.56382 10.0201L7.14463 11.4409L16.0874 11.44C16.3623 11.44 16.591 11.6381 16.6384 11.8994L16.6474 12C16.6474 12.2749 16.4493 12.5036 16.1881 12.551L16.0874 12.56L7.14463 12.5607L8.56382 13.9799C8.75821 14.1743 8.77981 14.4761 8.62862 14.6943L8.56382 14.7719C8.36942 14.9663 8.06767 14.9879 7.84942 14.8367L7.77186 14.7719L5.39598 12.396Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5b3e0b9a5d12763cec1b403bd8f8289d.svg";
export { ForwardRef as ReactComponent };